(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["real-people-fifo-wall"] && !Shopify.designMode) return;
  try {
    
/* ===============================
    Parallax per card (UP/Down)
    - Left column goes UP
    - Right column goes DOWN
    =============================== */
(function(){
  const wall = document.getElementById('fifo-wall');
  if(!wall) return;

  const gallery = wall.querySelector('.fifo-gallery');
  const cards = Array.from(gallery.querySelectorAll('.fifo-img'));

  // Mark left/right by index in 2-col flow
  function markCols(){
    cards.forEach((card, i)=>{
      card.dataset.col = (i % 2 === 0) ? 'left' : 'right';
    });
  }
  markCols();

  const MAX_SHIFT = 90; // px (visible)
  function clamp(v, min, max){ return Math.min(max, Math.max(min, v)); }

  let rafId;
  function onScroll(){
    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(update);
  }

  function update(){
    const vh = window.innerHeight || 800;

    cards.forEach((card)=>{
      const rect = card.getBoundingClientRect();
      const centerDelta = (rect.top + rect.height/2) - (vh/2);
      const norm = clamp(centerDelta / (vh/2), -1, 1);
      const dir = (card.dataset.col === 'left') ? -1 : 1;
      const shift = clamp(norm * MAX_SHIFT * dir, -MAX_SHIFT, MAX_SHIFT);
      card.style.setProperty('--shift', shift.toFixed(1) + 'px');
    });
  }

  // Check for reduced motion preference and only run if motion is preferred
  if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll, {passive:true});
    onScroll(); // initial
  }

})();

/* ===============================
    Tiny lightbox
    =============================== */
(function(){
  const lb = document.getElementById('lb-{{ section.id }}');
  const lbImg = document.getElementById('lb-img-{{ section.id }}');

  document.addEventListener('click', function(e){
    // Ensure the click is within this specific section's wall
    if (e.target.closest('#fifo-wall') !== document.getElementById('fifo-wall')) return;

    const img = e.target.closest('.fifo-img img');
    if(img){
      lbImg.src = img.currentSrc || img.src;
      lbImg.alt = img.alt || '';
      lb.classList.add('is-open');
      lb.setAttribute('aria-hidden','false');
      document.body.style.overflow = 'hidden';
    }
  });

  function closeLB(){
    lb.classList.remove('is-open');
    lb.setAttribute('aria-hidden','true');
    lbImg.src = '';
    document.body.style.overflow = '';
  }
  lb.addEventListener('click', function(e){
    if(e.target === lb || e.target === lbImg) closeLB();
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closeLB();
  }, {passive:true});
})();

  } catch(e) { console.error(e); }
})();
})();
